import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";
import Swal from 'sweetalert2';

const SubscriptionForm = () => {
  const navigate = useNavigate()

  const [toggleNav, setToggleNav] = useState(false)

  const [subscriptionPlan, setSubscriptionPlan] = useState("")
  const [paymentDate, setPaymentDate] = useState("")
  const [bank, setBank] = useState("")
  const [paymentChannel, setPaymentChannel] = useState("")
  const [depositorsName, setDepositorsName] = useState("")

  const [loading, setLoading] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    document.title = "Island Luxury - Payment Notification"
		if(!userInfo) {
			navigate("/")
		}
	}, [userInfo, navigate])

  const handleSubmitPayment = (e) => {
    e.preventDefault()
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo?.token}`
      }
    }
    const submit = async () => {
      try {
        setLoading(true)
        await axios.post(baseUrl + "/api/v1/subscriptions", {
          subscriptionPlan,
          paymentDate,
          bank,
          paymentChannel,
          depositorsName }, config)
        Swal.fire({
          icon: 'success',
          title: 'Posted',
          text: "Your payment notification have been saved!"
        })
        setSubscriptionPlan("")
        setPaymentDate("")
        setBank("")
        setPaymentChannel("")
        setDepositorsName("")
        setLoading(false)
      }
      catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${err.response && err.response.data.message ? err.response.data.message : err.message}`
        })
        setLoading(false)
      }
    }
    submit()
  }

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="subscription">
        <section className="page-title">
          <h3><Link to="/dashboard">Dashboard</Link> | <Link to="/plans">Subscription Plans</Link> | Payment Form</h3>
        </section>
        <div className="payment-form-info">
          <p>Payments into our accounts requires completing of the <Link to="/plans/payment-form">payment notification form</Link>.</p>
        </div>
        <section className="payment-form">
          <form onSubmit={handleSubmitPayment}>
            <h3>Bank Payment Notification</h3>
            <div className="form-grp">
              <label htmlFor="plan">Subscription Plan</label>
              <select id="plan" value={subscriptionPlan} onChange={(e) => setSubscriptionPlan(e.target.value)} required>
                <option>Select subscription plan</option>
                <option value="Basic">Basic ₦1000</option>
                <option value="Bronze">Bronze ₦3000</option>
                <option value="Silver">Silver ₦5000</option>
                <option value="Gold">Gold ₦10000</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="date">Payment Date</label>
              <input type="date" id="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} required />
            </div>
            <div className="form-grp">
              <label htmlFor="bank">Which of our banks used</label>
              <select id="bank" value={bank} onChange={(e) => setBank(e.target.value)} required >
                <option>Select the bank you paid into</option>
                <option value="Guaranty Trust Bank - 0621581895">Guaranty Trust Bank - 0621581895</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="paymentChannel">Payment Channel</label>
              <select id="paymentChannel" value={paymentChannel} onChange={(e) => setPaymentChannel(e.target.value)} required >
                <option>Select the payment channel used</option>
                <option value="Bank Deposit">Bank Deposit</option>
                <option value="USSD">USSD Transfer (e.g *737#)</option>
                <option value="Internet Banking">Internet Banking</option>
                <option value="ATM">Transfer from ATM</option>
                <option value="POS Transfer">POS Transfer</option>
                <option value="Mobile App">Mobile App</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="name">Depositor's Name | Your Bank Account's Name </label>
              <input type="text" id="name" value={depositorsName} onChange={(e) => setDepositorsName(e.target.value)} required />
            </div>
            <div className="form-grp_btn">
              <button type="submit" disabled={loading && true}>
                {loading ? "Submitting..." : "Submit Notification"}
              </button>
            </div>
          </form>
        </section>
      </main>
    </div>
  )
}

export default SubscriptionForm;